import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Collapse, Alert, Spin, Card } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css'; // Dành cho Ant Design v5

const { Panel } = Collapse;

// Map màu nền của trạng thái (dùng cho header)
const statusColorMap = {
  "": "#f0f0f0",              // Nếu trạng thái rỗng
  "da_nhan": "#1890ff",       // Tài xế đã nhận chuyến
  "capnhat_chuyen": "#fa8c16", // Tài xế đã đến điểm nhận hàng
  "hoan_tat": "#52c41a",       // Chuyến đã hoàn tất
  "huy_chuyen": "#ff4d4f"      // Chuyến đã hủy
};

// Map trạng thái để hiển thị text cho người dùng
const statusTextMap = {
  "": "Đơn hàng chưa được gán",
  "capnhat_chuyen": "Đơn hàng đã gán xe và tài xế",
  "da_nhan": "Đơn hàng đã nhận hàng và đang giao hàng",
  "hoan_tat": "Đơn hàng đã được giao thành công",
  "huy_chuyen": "Đơn hàng đã bị hủy"
};

const CustomerOrdersDashboardComponent = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch('/api/customer/orders');
      if (!response.ok) {
        throw new Error('Error fetching orders');
      }
      const data = await response.json();
      setOrders(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Render header của mỗi panel với bố cục hàng ngang
  const renderPanelHeader = (order) => {
    const status = order.trang_thai || "";
    const cardColor = statusColorMap[status] || "#ffffff";
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          backgroundColor: cardColor,
          padding: '10px 16px',
          borderRadius: '4px',
          fontSize: '14px'
        }}
      >
        <div style={{ flex: '1 1 25%', textAlign: 'left' }}>
          <strong>Mã chuyến:</strong> {order.id}
        </div>
        <div style={{ flex: '1 1 25%', textAlign: 'center' }}>
          <strong>Ngày vận chuyển:</strong> {new Date(order.ngay_van_chuyen).toLocaleDateString()}
        </div>
        <div style={{ flex: '1 1 25%', textAlign: 'center' }}>
          <strong>Điểm đi:</strong> {order.diem_di}
        </div>
        <div style={{ flex: '1 1 25%', textAlign: 'right' }}>
          <strong>Điểm đến:</strong> {order.diem_den}
        </div>
      </div>
    );
  };

  // Render nội dung chi tiết của mỗi panel
  const renderPanelContent = (order) => {
    const status = order.trang_thai || "";
    return (
      <Card style={{ marginTop: '10px' }} bordered={false}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <p><strong>Tên khách hàng:</strong> {order.ten_khach_hang}</p>
            <p><strong>Loại xe:</strong> {order.loai_xe}</p>
            <p>
              <strong>Thời gian kết thúc:</strong>{" "}
              {order.thoi_gian_ket_thuc ? new Date(order.thoi_gian_ket_thuc).toLocaleString() : 'N/A'}
            </p>
          </Col>
          <Col xs={24} md={12}>
            <p>
              <strong>Vị trí kết thúc (Lat, Lon):</strong>{" "}
              {order.lat_ket_thuc && order.lon_ket_thuc ? `${order.lat_ket_thuc}, ${order.lon_ket_thuc}` : 'N/A'}
            </p>
            <p>
              <strong>Trạng thái:</strong> {statusTextMap[status] || "Đơn hàng chưa được gán"}
            </p>
            <p>
              <strong>Thời gian hoàn thành:</strong>{" "}
              {order.thoi_gian_hoan_thanh ? new Date(order.thoi_gian_hoan_thanh).toLocaleString() : 'N/A'}
            </p>
            <p><strong>Biển kiểm soát:</strong> {order.bien_kiem_soat || 'N/A'}</p>
            <p><strong>Tài xế:</strong> {order.tai_xe || 'N/A'}</p>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <Container fluid className="py-4">
      <h2 className="text-center mb-4">Thông Tin Đơn Hàng Của Bạn</h2>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin tip="Đang tải..." size="large" />
        </div>
      ) : error ? (
        <Alert
          message="Lỗi"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: '20px' }}
        />
      ) : (
        <Collapse accordion bordered={false}>
          {orders.map((order) => (
            <Panel header={renderPanelHeader(order)} key={order.id}>
              {renderPanelContent(order)}
            </Panel>
          ))}
        </Collapse>
      )}
    </Container>
  );
};

export default CustomerOrdersDashboardComponent;